import React from 'react';
import { Route, Routes } from 'react-router-dom';
import DocumentationSidebar from './DocumentationSidebar';
import About from './About';
import HowToRun from './HowToRun';
import TechnicalDocumentation from './TechnicalDocumentation';
import { Container, Row, Col } from 'react-bootstrap';
import DecisionDocumentation from './DecisionDocumentation';
import AgentPromptDocumentation from './AgentPromptDocumentation'; 
import LicenseInformation from './LicenseInformation';
import InvestorNotes from './InvestorNotes';
import ToolDocumentation from './ToolDocumentation';
import CodeDocumentation from './CodeDocumentation';
import Costing from './Costing';
import DependencyDocumentation from './DependencyDocumentation';
import AuthDocumentation from './AuthDocumentation';
import SecurityDocumentation from './SecurityDocumentation';

const Documentation = () => {
    return (
        <Container className="mt-5">
            <Row>
                <Col md={3}>
                    <DocumentationSidebar />
                </Col>
                <Col md={9}>
                    <Routes>
                        <Route path="tool-documentation" element={<ToolDocumentation />} />
                        <Route path="about" element={<About />} />
                        <Route path="how-to-run" element={<HowToRun />} />
                        <Route path="technical" element={<TechnicalDocumentation />} />
                        <Route path="decision-documentation" element={<DecisionDocumentation />} /> 
                        <Route path="agent-prompt-documentation" element={<AgentPromptDocumentation />} />
                        <Route path="license" element={<LicenseInformation />} />
                        <Route path="investor-notes" element={<InvestorNotes />} />
                        <Route path="code-documentation" element={<CodeDocumentation />} />
                        <Route path="costing" element={<Costing />} />
                        <Route path="dependency-documentation" element={<DependencyDocumentation />} />
                        <Route path="auth-documentation" element={<AuthDocumentation />} />
                        <Route path="security-documentation" element={<SecurityDocumentation />} />
                        <Route path="" element={<About />} />
                    </Routes>
                </Col>
            </Row>
        </Container>
    );
};

export default Documentation;
